import React from 'react';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';

import FilterableCard from 'HVRA/components/FilterableCard';
import FilterableSlider from 'HVRA/components/FilterableSlider';

const singleFilterCard = (item, onRangeChange, onSwitchChange) => {
  return (
    <FilterableCard
      key={item.id}
      item={item}
      excludable={item.excludable}
      headerText={item.label}
      toolTip={item.toolTip}
      onSwitchChange={onSwitchChange}
    >
      <Box sx={{ display: 'flex', flexDirection: 'row' }}>
        <Box sx={{ minWidth: '73px', fontSize: '11px', textAlign: 'center' }}>
          Lowest
        </Box>
        <Box sx={{ minWidth: '73px', fontSize: '11px', textAlign: 'center' }}>
          Low
        </Box>
        <Box sx={{ minWidth: '73px', fontSize: '11px', textAlign: 'center' }}>
          Medium
        </Box>
        <Box sx={{ minWidth: '73px', fontSize: '11px', textAlign: 'center' }}>
          High
        </Box>
        <Box sx={{ minWidth: '73px', fontSize: '11px', textAlign: 'center' }}>
          Highest
        </Box>
      </Box>
      <FilterableSlider item={item} filters={item.filters} onRangeChange={onRangeChange}></FilterableSlider>
    </FilterableCard>
  );
};

const FilterableTabPanel = ({ filterGroups, onFilterChange, onSwitchChange }) => {
  if (!filterGroups || filterGroups.length == 0) return null;
  
  const filtArray = filterGroups.map((item) => {
    return singleFilterCard(item, onFilterChange, onSwitchChange);
  });

  return (
    <>
      {filtArray}
      <Box>
        <FilterableCard excludable={false} headerText={'Legend'}>
          <Box sx={{ display: 'flex', flexDirection: 'row' }}>
            <Box sx={{ minWidth: '73px', backgroundColor: '#16E5F1' }}>
              &nbsp;
            </Box>
            <Box sx={{ minWidth: '73px', backgroundColor: '#17C4D3' }}>
              &nbsp;
            </Box>
            <Box sx={{ minWidth: '73px', backgroundColor: '#198F99' }}>
              &nbsp;
            </Box>
            <Box sx={{ minWidth: '73px', backgroundColor: '#004052' }}>
              &nbsp;
            </Box>
            <Box sx={{ minWidth: '73px', backgroundColor: '#000B1B' }}>
              &nbsp;
            </Box>
          </Box>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
            }}
          >
            <Box>Lowest</Box>
            <Box>Highest</Box>
          </Box>
        </FilterableCard>
      </Box>
    </>
  );
};

FilterableTabPanel.propTypes = {
  filterGroups: PropTypes.array.isRequired,
  onFilterChange: PropTypes.func,
  onSwitchChange: PropTypes.func
};

export default FilterableTabPanel;
